import { SelectOption } from '../../searchableSelect/searchableSelectTypes';
import { useLanguage } from '../../../context/LanguageContext';
import { useTransaction } from '../../../context/TransactionContext';
import { useTransactionTypeList } from '../../../hooks/useTransactionTypeList';
import { useTransactionTypeSelectFilters } from './useTransactionTypeSelectFilters';
import {
  buildTransactionTypeSelection,
  getTransactionTypeName,
  getTransactionTypeSubject,
} from './transactionTypeSelection';

/** The props `SearchableSelect` needs to pick a transaction type, from the list the picker screen uses. */
export const useTransactionTypeSelect = () => {
  const { transaction, updateTransaction } = useTransaction();
  const { getAppLanguageCode } = useLanguage();
  const transactionTypeList = useTransactionTypeList();
  const {
    formatedTransactionType,
    setSearchValue,
    fetchNextPage,
    hasNextPage,
    isTransactionTypeLoading,
    isFetchingNextPage,
  } = transactionTypeList;
  const filters = useTransactionTypeSelectFilters(transactionTypeList);
  const appLanguage = getAppLanguageCode();

  const options: SelectOption[] = formatedTransactionType.map((type) => ({
    value: type.id,
    label: getTransactionTypeName(type.translations, appLanguage),
  }));
  const value: SelectOption | null = transaction?.transactionType?.id
    ? {
        value: transaction.transactionType.id,
        label: getTransactionTypeName(transaction.transactionType.translations, appLanguage),
      }
    : null;

  const onChange = (option: SelectOption) => {
    const type = formatedTransactionType.find(({ id }) => id === option.value);
    if (!type) return;
    const subject = getTransactionTypeSubject(
      type.translations,
      transaction?.matter?.language,
      appLanguage,
    );
    updateTransaction(buildTransactionTypeSelection(transaction, type, subject));
  };

  return {
    options,
    value,
    filters,
    onChange,
    onSearch: setSearchValue,
    onLoadMore: fetchNextPage,
    hasMore: Boolean(hasNextPage),
    loading: isTransactionTypeLoading,
    loadingMore: isFetchingNextPage,
  };
};
